var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.833496L0.5 4.16683V9.16683C0.5 13.796 3.69583 18.1127 8 19.1668C12.3042 18.1127 15.5 13.796 15.5 9.16683V4.16683L8 0.833496ZM6.33333 14.1668L3 10.8335L4.17917 9.65433L6.33333 11.8085L11.8208 6.321L13 7.50016L6.33333 14.1668Z",
    fill: "#14AC63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSuccess);
export default __webpack_public_path__ + "static/media/LoginSuccess.986713556a1c375f4df16602046eab5b.svg";
export { ForwardRef as ReactComponent };